export default {"src":"/_next/static/media/BWA.274fb644.svg","height":18,"width":18};